module.exports = __webpack_public_path__ + "static/media/loreal3.89937879.jpg";